<div class="layout-column custom-panel full-width full-height padding-5 gap-5">
  <div class="header layout-column justify-content-between">
    <div class="layout-row justify-content-between align-items-center">
      <div class="layout-row gap-5 align-items-center">
        <bringoz-icon iconName="location-pin-outline" class="gray-100"></bringoz-icon>
        <span class="flex font-weight-600 gray-100" translate>Add Middle Stop</span>
      </div>
      <bringoz-button type="tertiary"
                      (click)="close()"
                      size="sm">
        <bringoz-icon iconName="close"></bringoz-icon>
      </bringoz-button>
    </div>
    <hr/>
  </div>


  <div class="layout-column overflow-y-auto flex-grow-1">
    <div class="layout-column gap-5">
      <span class="gray-100" translate>Currently</span>
      <div class="layout-row gap-5">
        <span>{{initialTaskDetails.from | bringozAddress}}</span>
        <bringoz-icon iconName="arrow-right"></bringoz-icon>
        <span>{{initialTaskDetails.to | bringozAddress}}</span>
      </div>
      <hr/>
    </div>

    <div class="layout-column padding-top-10 gap-5">
      <app-depot-select
        [excludeIds]="excludedDepotIds"
        [ngPlaceholder]="'Select Depot' | translate"
        [event]="event"
        [buttonSize]="'sm'"
        (onChange)="onDepotSelected($event)">
      </app-depot-select>
      <hr/>
    </div>

    <div class="flex layout-column gap-5">
      <div class="flex layout-column gap-5" *ngIf="selectedDepot; else noDepotSelected">
        <span translate>Result</span>
        <div class="layout-row gap-5">
          <span style="min-width: 30px">{{'Job' | translate}} 1:</span>
          <span class="text-width-limit-50">{{initialTaskDetails.from | bringozAddress}}</span>
          <bringoz-icon iconName="arrow-right"></bringoz-icon>
          <span class="font-weight-600 text-width-limit-50">{{selectedDepot.name}}</span>
        </div>
        <div class="layout-row gap-5">
          <span style="min-width: 31px">{{'Job' | translate}} 2:</span>
          <span class="font-weight-600 text-width-limit-50">{{selectedDepot.name}}</span>
          <bringoz-icon iconName="arrow-right"></bringoz-icon>
          <span class="text-width-limit-50">{{initialTaskDetails.to | bringozAddress}}</span>
        </div>
      </div>
      <ng-template #noDepotSelected>
        <div class="flex layout-column align-items-center justify-content-center">
          <span class="gray-100" translate>Please select a depot</span>
          <bringoz-icon iconName="depot" size="xxl"></bringoz-icon>
        </div>
      </ng-template>
    </div>
  </div>



  <div class="layout-column">
    <hr/>
    <div class="layout-row justify-content-between">
      <bringoz-button size="sm" type="tertiary"
                      (click)="close()">
        <span translate>Cancel</span>
      </bringoz-button>
      <div class="layout-row gap-5">
        <bringoz-button size="sm" theme="secondary"
                        [isDisabled]="!selectedDepot"
                        (click)="insertStop()">
          <span translate>Add Stop</span>
        </bringoz-button>
      </div>
    </div>
  </div>

</div>
